import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { AppAntSwitch, AppAsyncOfficesAutocomplete } from "@components"
import { Grid } from "@mui/material"
import { useSignal } from "@preact/signals-react"

export default function OneWayRoutesField() {

	const showOneWays = useSignal(!!reportFormData.peek()?.oneWayRoutes?.length)

	const {
		oneWayRoutes,
		setOneWayRoutesInfo,
		error
	} = useReportFormInfo(reportFormData.peek().oneWayRoutes, "oneWayRoutes", object({ oneWayRoutes: array() }))

	return <Grid container spacing={2}>
		<Grid item xs={8}>
			{showOneWays.value && <AppAsyncOfficesAutocomplete
				multiple
				label="One Way Office Routes"
				placeholder="Select One Way Office Routes"
				value={oneWayRoutes || []}
				error={error}
				onChange={e => setOneWayRoutesInfo(e.target.value)}
			/>}
		</Grid>
		<Grid item xs={4}>
			<AppAntSwitch
				trueText="One Ways"
				checked={showOneWays.value}
				onChange={() => showOneWays.value = !showOneWays.value}
			/>
		</Grid>
	</Grid>
}